import { render, staticRenderFns } from "./AppProductPicker.vue?vue&type=template&id=3b55bb8f&scoped=true"
import script from "./AppProductPicker.vue?vue&type=script&lang=js"
export * from "./AppProductPicker.vue?vue&type=script&lang=js"
import style0 from "./AppProductPicker.vue?vue&type=style&index=0&id=3b55bb8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b55bb8f",
  null
  
)

export default component.exports